import { Pipeline } from '@payaca/types/pipelineTypes';
import { action } from 'typesafe-actions';
import { ActionType } from './pipelineTypes';

export const requestGetAccountPipelines = () => {
  return action(ActionType.REQUEST_GET_ACCOUNT_PIPELINES);
};

export const getAccountPipelinesSuccess = (pipelines: Pipeline[]) => {
  return action(ActionType.GET_ACCOUNT_PIPELINES_SUCCESS, pipelines);
};

export const getAccountPipelinesFailure = (error: Error) => {
  return action(ActionType.GET_ACCOUNT_PIPELINES_FAILURE, null, null, error);
};

export const clearPipelines = () => {
  return action(ActionType.CLEAR_PIPELINES);
};
